
// DEPARTMENTS
export const GET_DEPARTMENTS = "/departments";
export const ADD_NEW_DEPARTMENT = "/departments";
export const UPDATE_DEPARTMENT = "/departments";
export const DELETE_DEPARTMENT = "/departments";


